<script>
  export let type = null;
  export let id;
  export let value;
  // export let multivalue = [];
  export let label;

  export let valid = true;
  export let validityMessage = "";

  let touched = false;
  let multivalue = ["Tomatoes", "Cucumbers", "Peas"];
  let values = multivalue;
</script>

<div class="form-control">
  <h3><label for={id}>{label}</label></h3>
  {#if type === "text"}
    <input
      class:invalid={!valid && touched}
      {type}
      {id}
      {value}
      on:input
      on:blur={() => (touched = true)}
    />
  {:else if type === "date"}
    <input
      class:invalid={!valid && touched}
      {type}
      {id}
      {value}
      on:input
      on:blur={() => (touched = true)}
    />
  {:else if type === "multiselect"}
    <div>
      <select
        multiple
        name={id}
        {id}
        bind:value={values}
        on:input
        on:blur={() => (touched = true)}
      >
        {#each multivalue as value}
          <option {value}>
            {value}
          </option>
        {/each}
      </select>
    </div>
  {/if}
  {#if validityMessage && !valid && touched}
    <p class="error-message">{validityMessage}</p>
  {/if}
</div>

<style>
  input {
    display: block;
    width: 100%;
    font-size: 1rem;
    border: none;
    border-bottom: 2px solid #ccc;
    border-radius: 3px 3px 0 0;
    background: white;
    padding: 0.15rem 0.25rem;
    transition: border-color 0.1s ease-out;
  }

  input:focus,
  textarea:focus {
    border-color: #017e3d;
    outline: none;
  }

  label {
    display: block;
    font-size: 1.25rem;
    margin-bottom: 0.5rem;
    width: 100%;
  }

  .form-control {
    padding: 0.5rem 0;
    padding-top: 0.75rem;
    width: 100%;
    margin: 0.25rem 0;
  }

  .invalid {
    border-color: darkred;
    border-color: rgb(211, 198, 198);
  }
  
  .error-message {
    color: darkred;
    margin: 0.25rem 0;
  }

</style>
